<template>
  <v-container>
    <v-app-bar
      flat
      color="primary"
      role="navigation"
    >
      <v-toolbar-title class="text-body-2">
        {{ $t("components.downloads.title") }}
      </v-toolbar-title>
      <v-progress-linear
        v-show="isLoading"
        color="accent"
        indeterminate
        role="progressbar"
        aria-label="Loading download items"
      />
    </v-app-bar>

    <v-layout wrap>
      <v-flex
        v-for="game in games"
        :key="game.id"
        v-bind="{
          [`xs${game.flexExtraSmall} sm${game.flexSmall} md${game.flexMedium} lg${game.flexLarge}`]: true
        }"
        :aria-labelledby="`game-title-${game.id}`"
        role="region"
        height="150px"
      >
        <v-card
          v-if="game.isActive"
          outlined
        >
          <v-img
            :alt="`${$t(game.title)} preview image`"
            :src="game.img"
            height="80px"
            role="img"
          />

          <div
            class="v-list-item-download-labels downloadCards"
            aria-hidden="true"
          >
            <span
              v-if="game.isNew"
              class="downloadLabel downloadNew"
            >New</span>
            <span
              v-if="game.isRecommend"
              class="downloadLabel downloadRecommend"
            >Recommend</span>
            <span
              v-if="game.isRecommend"
              class="downloadLabel downloadComingSoon"
            >Coming Soon</span>
          </div>

          <v-card-title primary-title>
            <div>
              <h3
                :id="`game-title-${game.id}`"
                class="h5"
              >
                {{ $t(game.title) }}
              </h3>
              <span class="grey--text text-subtitle-2">
                {{ $t(game.subtitle) }}
              </span>
            </div>
          </v-card-title>

          <v-card-actions>
            <v-btn
              :aria-label="`${$t('components.downloads.buttons.download')} ${$t(game.title)}`"
              text
              color="accent"
              @click="viewGameCard(game.link)"
            >
              {{ $t("components.downloads.buttons.download") }}
            </v-btn>
            <v-spacer />
            <v-btn
              :aria-label="`${isCardVisible(game.id) ? 'Hide' : 'Show'} description of ${$t(game.title)}`"
              icon
              :color="isCardVisible(game.id) ? 'accent' : ''"
              @click="toggleGameCard(game.id)"
            >
              <v-icon>
                {{ isCardVisible(game.id) ? "keyboard_arrow_down" : "keyboard_arrow_up" }}
              </v-icon>
            </v-btn>
          </v-card-actions>

          <v-slide-y-transition>
            <v-card-text v-show="isCardVisible(game.id)">
              {{ $t(game.brief) }}
            </v-card-text>
          </v-slide-y-transition>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import games from "@/constants/download.games.js";

export default {
    name: "DownloadGames",
    data() {
        return {
            games: games.list,
            cardsOptions: [],
            isLoading: false
        }
    },
    beforeMount() {
        this.isLoading = true;
        // Setup our state
        this.games.map(({ id }) => {
            this.cardsOptions[id] = {
                visibile: false
            };
        });
    },
    mounted() {
        this.isLoading = false;
    },
    methods: {
        /**
         * Will handle the toggle of showing the text for the current card
         */
        toggleGameCard(id) {
            this.cardsOptions.splice(id, 1, {
                ...this.cardsOptions[id],
                visibile: !this.cardsOptions[id].visibile
            });
        },
        /**
         * Will handle the view game card to external url
         */
        viewGameCard(link) {
            if (link) {
                // track event
                // this.$ga.event("download-game", "link", link);
                // go to page
                window.open(link);
            }
        },
        /**
         * Check if card visible or not
         */
        isCardVisible(id) {
            return this.cardsOptions[id].visibile;
        }
    }
};
</script>
